<template>
  <div class="row mt-4">
    <RuleModal :is-opened="isModalOpen" @close="isModalOpen = false" />
    <div class="col-sm-6 col-md-3">
      <div class="widget-rounded-circle card-box border" :class="isActive ? 'text-success border-success' : 'text-danger border-danger'">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <div>{{ trans.get('image_verification.you_are') }}</div>
            <h2 v-if="isActive" class="text-success">{{ trans.get('image_verification.active') }}</h2>
            <h2 v-else class="text-danger">{{ trans.get('image_verification.inactive') }}</h2>
          </div>
          <div>
            <SwitchComponent v-model="isActive" />
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-md-3">
      <div class="widget-rounded-circle card-box fixed-height">
        <div class="text-danger">
          <h4 class="text-danger m-0">{{ formattedDuration }} {{ trans.get('image_verification.seconds') }}</h4>
          <div>{{ trans.get('image_verification.average_time') }}</div>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-md-3">
      <div class="widget-rounded-circle card-box text-success fixed-height">
        <h4 class="text-success m-0">{{ count }} {{ trans.get('image_verification.images_verified') }}</h4>
        <div>{{ trans.get('image_verification.this_month') }}</div>
      </div>
    </div>
    <div v-if="isActive" class="col-sm-6 col-md-3">
      <div class="widget-rounded-circle card-box d-flex align-items-center text-secondary fixed-height">
        <img src="../../../images/icons/info.svg" class="mr-2" alt="">
        <h4>
          <button class="text-secondary" @click="openModal">
            {{ trans.get('image_verification.guidelines_and_rules') }}
          </button>
        </h4>
      </div>
    </div>
  </div>
</template>

<script>
import SwitchComponent from '../Common/SwitchComponent.vue';
import RuleModal from './RulesModal.vue';

export default {
  name: 'ImageVerificationHeader',
  components: { RuleModal, SwitchComponent },
  props: {
    modelValue: Boolean,
    count: {
      type: [String, Number],
      required: true,
    },
    duration: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      isModalOpen: false,
    };
  },
  computed: {
    isActive: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    },
    formattedDuration() {
      return Number(this.duration / 1000).toFixed(2);
    },
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value);
    },
    openModal() {
      this.isModalOpen = true;
    },
  },
  mounted() {
  }
};
</script>

<style scoped lang="scss">
.fixed-height {
  height: 105px;
}

button {
  background: none;
  border: none;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    opacity: 0.85;
  }
}
</style>